import DocumentBlocks from "./DocumentBlocks";

export default DocumentBlocks;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentBlocks/index.js